/* eslint-disable */
<template>
  <div class="bookings-requiring-action">
    <AdminNavigation ref="navigation" indexProps="5" />
    <div class="top-panel">
      <Header />
      <div class="header-title-section">
        <div class="header-title"><h1>Bookings Requiring Action</h1></div>
        <div class="header-sub-title">Clients have requested action on the bookings listed below. View quick notes or click through to access the booking. Update the status of the request below.</div>
      </div>
    </div>
    <div class="panel">
      <AdminBookingsMenu indexProps="4" />
      <div class="content">
        <div class="tool-bar row">
          <div class="col d-flex justify-content-end">
            <el-input style="max-width: 200px" clearable class="mr-1" placeholder="Assigned to" @input="search()" v-model="listParam.AssignedUser" />
            <el-input style="max-width: 200px" clearable class="mr-1" placeholder="Client" @input="search()" v-model="listParam.ClientName" />
            <el-input style="max-width: 200px" clearable class="mr-1" placeholder="Client Contact" @input="search()" v-model="listParam.ContactName" />
            <el-input style="max-width: 200px" clearable class="mr-1" placeholder="Examinee Name" @input="search()" v-model="listParam.ClaimantName" />
            <el-select style="max-width: 200px" class="mr-1" placeholder="Status" @change="search()" clearable v-model="listParam.Status" >
              <el-option v-for="item in bookingRequestStatuses" :key="item.id" :value="item.id" :label="item.name"></el-option>
            </el-select>
          </div>
        </div>

        <div v-if="fetchedData" class="content-scroll-x">
          <div>
            <div>
              <el-table :default-sort="{prop: 'Submitted', order: 'descending'}" :data="bookings" stripe @sort-change="sortParam" tooltip-effect="dark" :header-row-style="{background: '#fde9eb', height: '70px'}" :header-cell-style="{fontWeight: 100}">
                <el-table-column
                    width="120"
                    show-overflow-tooltip
                    label="Booking ID"
                    sortable="custom"
                    prop="bookingId"
                >
                  <template slot-scope="scope">
                    <router-link
                        :to="{
                          name: 'admin-manage-booking',
                          query: { id: scope.row.bookingId },
                        }"
                    >{{ scope.row.bookingId }}</router-link
                    >
                  </template>
                </el-table-column>
                <el-table-column
                    width="180"
                    show-overflow-tooltip
                    label="Client Contact"
                    sortable="custom"
                    prop="ClientContact"
                >
                  <template slot-scope="scope">
                    <router-link
                        :to="{
                          name: 'admin-edit-client-contact',
                          query: { id: scope.row.ClientContact.ClientContactID, type: 'edit-contact' },
                        }"
                        class="d-flex position-relative"
                    >
                      <el-tooltip  effect="dark" :content="scope.row.clientContactFullName" placement="bottom">
                        <span>{{ scope.row.clientContactFullName }}</span>
                      </el-tooltip>
                      <span
                          class="is-icon right-element"
                          data-placement="right"
                          data-toggle="tooltip"
                          :title="scope.row.requestedAction"
                      ><img src="@/assets/images/note_dark_icon.svg"
                      /></span>
                    </router-link>
                  </template>
                </el-table-column>
                <el-table-column
                    width="180"
                    show-overflow-tooltip
                    label="Client"
                    sortable="custom"
                    prop="Client"
                >
                  <template slot-scope="scope">
                    <router-link
                        :to="{
                          name: 'admin-manage-client',
                          query: { id: scope.row.clientId },
                        }"
                    >
                      <el-tooltip  effect="dark" :content="scope.row.clientBranchName" placement="bottom">
                        <span>{{ scope.row.clientBranchName }}</span>
                      </el-tooltip>
                    </router-link>
                  </template>
                </el-table-column>
                <el-table-column
                    width="180"
                    show-overflow-tooltip
                    label="Examinee"
                    sortable="custom"
                    prop="Claimant"
                >
                  <template slot-scope="scope">
                    <router-link
                        :to="{
                          name: 'admin-manage-case',
                          query: { id: scope.row.caseId },
                        }"
                    >
                      <el-tooltip  effect="dark" :content="scope.row.claimantFullName" placement="bottom">
                        <span>{{ scope.row.claimantFullName }}</span>
                      </el-tooltip>
                    </router-link>
                  </template>
                </el-table-column>
                <el-table-column
                    width="190"
                    show-overflow-tooltip
                    label="Submitted"
                    sortable="custom"
                    prop="Submitted"
                >
                  <template slot-scope="scope">
                    <el-tooltip  effect="dark" :content="formatDate(scope.row.dateRequested,  'DD/MM/YYYY hh:mm A', 'YYY-MM-DD HH:mm:ss' )" placement="bottom">
                        <span>{{
                            formatDate(
                                scope.row.dateRequested,
                                "DD/MM/YYYY hh:mm A",
                                "YYYY-MM-DD HH:mm:ss"
                            )
                          }}</span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                    width="140"
                    show-overflow-tooltip
                    label="Status"
                    sortable="custom"
                    prop="Status"
                >
                  <template slot-scope="scope">
                    <select
                        class="w-100 textbox"
                        v-model="scope.row.status"
                        @change="changeBookingStatus(scope.$index)"
                    >
                      <option hidden value="">Select ...</option>
                      <option
                          v-for="(booking, index) in bookingRequestStatuses"
                          :key="index"
                          :value="booking.id"
                      >
                        {{ booking.name }}
                      </option>
                    </select>
                  </template>
                </el-table-column>
                <el-table-column
                    width="140"
                    show-overflow-tooltip
                    label="Assigned To"
                    sortable="custom"
                    prop="AssignedTo"
                >
                  <template slot-scope="scope">
                    <el-select
                        class="w-100"
                        :loading="loading" filterable
                        v-model="scope.row.assignedTo"
                        @change="changeAssignedTo(scope.$index)"
                    >
                      <el-option v-for="(user, index) in users" :key="index" :value="user.id" :label="user.name">
                        {{ user.name }}
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    label=" "
                >
                  <template slot-scope="scope">
                    <a :href="scope.row.zohoLink" target="_blank"
                    ><img
                        src="@/assets/images/zoho_icon.svg"
                        data-placement="right"
                        data-toggle="tooltip"
                        title="Link to Zoho"
                    /></a>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <div v-if="totalCount > listParam.pageSize" class="pagination">
          Page
          <div class="pagination-group">
            <div class="border-icon pagination-current dropdown">
              <div class="pagination-current-text">{{ listParam.pageNum }}</div>
              <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></div>
              <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :key="item" :class="listParam.pageNum === item ? 'selected' : ''" :value="item" @click="selectPage(item)">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount/listParam.pageSize) }}</div>
        </div>
        <div class="alert alert-success hidden-element">
          <a class="close" title="close">×</a>
          <b>Success:</b> {{ successMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from "@/assets/js/utilities"
import AdminNavigation from "@/components/AdminNavigation"
import AdminBookingsMenu from "@/components/AdminBookingsMenu"
import Header from "@/components/Header"
import { debounce } from 'lodash';

export default {
  name: "AdminBookingsAwaitingDictation",
  components: {
    AdminNavigation,
    AdminBookingsMenu,
    Header,
  },
  data() {
    return {
      totalCount: 0,
      fetchedData: false,
      successMessage: "",
      loading: false,
      bookings: [],
      allBookings: [],
      limit: 10,
      pagination: utilities.initPagination(),

      byClientContact: false,
      byClient: false,
      byClaimant: false,
      bySubmitted: false,
      byStatus: false,
      byAssignedTo: false,
      byBookingId: false,

      searchAssignedTo: '',
      searchClient: '',
      searchClientContact: '',
      userParam: {
        pageSize: 999,
        pageNum: 1,
        UserRoleIDs: '3,6'
      },
      users: [],
      bookingRequestStatuses: [],
      listParam: {
        pageSize: 10,
        pageNum: 1,
        orderBy: 'Submitted',
        ascOrDesc: 'DESC',
        AssignedUser: '',
        ClaimantName: '',
        ClientName: '',
        ContactName: '',
        Status: null
      },
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
  },
  methods: {
    async remoteMethod(query) {
      this.userParam.UserName = query
      this.loading = true
      this.users = users.filter(item => item.status)
      this.loading = false
    },
    selectPage(index) {
      this.listParam.pageNum = index
      this.loadBookingActions()
    },
    sortParam( v ) {
      this.listParam.orderBy = v.prop
      if(v.order === "ascending") {
        this.listParam.ascOrDesc = 'ASC'
      } else if (v.order === "descending") {
        this.listParam.ascOrDesc = 'DESC'
      } else {
        this.listParam.orderBy = null
        this.listParam.ascOrDesc = null
      }

      this.selectPage(1)
    },
    search: debounce(function () {
      this.selectPage(1)
    }, 800),
    formatDate(dateToFormat, newFormat, currentFormat) {
      return utilities.formatDate(dateToFormat, newFormat, currentFormat)
    },
    async changeBookingStatus(index) {
      this.$store.dispatch("loading/setLoadComponent", true)
      if(this.bookings[index].status != 1 && this.bookings[index].assignedTo == '') {
        // Assigned to person who logged in
        this.bookings[index].assignedTo = this.user.id
        var id = this.bookings[index].id
        var status = Number(this.bookings[index].status)
        var i = this.allBookings.findIndex(x => x.id == id)
        if(i > -1) {
          this.allBookings[i].status = status
          this.allBookings[i].assignedTo = this.user.id
        }
      }
      var result = await this.putBookingAction(index)
      if (result) {
        this.successMessage = "Booking action updated successfully."
        utilities.showAlert(".alert-success")
      }
      this.$store.dispatch("loading/setLoadComponent", false)
    },
    async changeAssignedTo(index) {
      this.$store.dispatch("loading/setLoadComponent", true)
      // Change status to assigned
      this.bookings[index].status = '2'
      var id = this.bookings[index].id
      var assignedTo = Number(this.bookings[index].assignedTo)
      var i = this.allBookings.findIndex(x => x.id == id)
      if(i > -1) {
        this.allBookings[i].status = 2
        this.allBookings[i].assignedTo = assignedTo
      }
      var result = await this.putBookingAction(index)
      if (result) {
        this.successMessage = "Booking action updated successfully."
        utilities.showAlert(".alert-success")
      }
      this.$store.dispatch("loading/setLoadComponent", false)
    },
    putBookingAction(index) {
      var params = {
        AssignedTo: Number(this.bookings[index].assignedTo),
        BookingActionRequestStatus: this.bookings[index].status,
      }

      var callback = (response) => {
        // Reload if change to Completed
        if(this.bookings[index].status == 3) this.loadBookingActions()
      }
      return utilities.putBookingAction(this.bookings[index].id, params, callback)
    },

    async loadBookingActions() {
      this.$store.dispatch("loading/setLoadComponent", true)
      let {data, total} = await utilities.getBookingActionsNew(this.listParam)
      let bookings = data
      this.totalCount = total
      this.allBookings = _.cloneDeep(bookings)
      this.bookings = _.cloneDeep(bookings)
      this.allBookings.filter(item => item.assignedTo).forEach(item => {
        if(this.users.filter(user => user.id === item.assignedTo).length === 0) {
          this.users.push({id: item.assignedTo, name: decodeURIComponent(item.assignedToName)})
        }
      })
      this.$store.dispatch("loading/setLoadComponent", false)
    },

    async loadData() {
      const apiArr = [utilities.getBookingActionsNew(this.listParam), utilities.choiceUser(this.userParam)]
      const r = await Promise.all(apiArr)
      let {data, total} = r[0]
      const bookings = data.filter(x => x.status != 3)
      this.totalCount = total
      this.allBookings = _.cloneDeep(bookings)
      this.bookings = bookings
      this.users = r[1]
      console.log(this.users)
      this.bookingRequestStatuses = utilities.getBookingRequestStatuses()
    },
  },
  async beforeMount() {
    this.$store.dispatch("loading/setLoadComponent", true)
    $("body>.tooltip").remove()
    await this.loadData()
    this.fetchedData = true
    this.$store.dispatch("loading/setLoadComponent", false)
  },
}
</script>
